import { Mesh } from 'three';
import React from 'react';

export default {
    name: '[pipe]elbow',
    prototype: 'holes',

    info: {
        tag: ['elbow'],
        title: 'Elbow',
        description: 'Еlbow',
        image: require('./elbow.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 35
            }
        },
        flip_horizzontal: {
            label: 'flip orizzontale',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        },
        flip_vertical: {
            label: 'vertical flip',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        },
    },

    render2D: function (element, layer, scene) {

        let width = element.properties.get('width').get('length');
        let flipHorizontal = element.properties.get('flip_horizzontal');
        let flipVertival = element.properties.get('flip_vertical');

        return (
            <g transform={`scale(${flipHorizontal ? -1 : 1}, ${flipVertival ? -1 : 1})`}>
                <g transform={`translate(0, -2) scale(${width * 0.07} ${width * 0.07}) rotate(90)`}>
                    <rect x="5" y="-2" height="4" width="3" stroke="#000000" fill="#000000" />
                    <rect x="2" y="-1" height="2" width="4" stroke="#000000" fill="#000000" />
                    <rect x="0" y="-5" height="6" width="2" stroke="#000000" fill="#000000" />
                    <rect x="-1" y="-8" height="3" width="4" stroke="#000000" fill="#000000" />
                </g>
            </g>
        );

    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
